<template>
    <div v-show="showBody">
        <van-card
                :price="params.money"
                :origin-price="params.promotion_money"
                :title="params.name"
                :thumb="params.cover"
                style="background-color: #fff"
        />

        <div style="margin-top: 10px">
            <!-- 优惠券单元格 -->
            <van-coupon-cell
                    :coupons="coupons"
                    :chosen-coupon="chosenCoupon"
                    @click="showList = true"
            />
            <!-- 优惠券列表 -->
            <van-popup
                    v-model="showList"
                    round
                    position="bottom"
                    style="height: 90%; padding-top: 4px;"
            >
                <van-coupon-list
                        :chosen-coupon="chosenCoupon"
                        :coupons="coupons"
                        :disabled-coupons="disabledCoupons"
                        @change="onChange"
                        :show-exchange-bar="false"
                />
            </van-popup>
        </div>

        <div class="payment">
            合计金额：<span class="payment-money">￥{{money}}</span>
            <span class="go-payment" @click="payOrder">去支付</span>
        </div>
    </div>
</template>

<script>
    import { Card ,CouponCell, CouponList,Popup,Toast} from 'vant';
    export default {
        name: "index",
        components:{
            [Card.name]:Card,
            [CouponCell.name]:CouponCell,
            [CouponList.name]:CouponList,
            [Popup.name]:Popup,
        },
        data(){
            return {
                id:'',
                type: 1, //默认 1为课程,2为训练营
                showBody:false,
                params:{},
                showList:false,
                chosenCoupon: -1,
                coupons: [],
                disabledCoupons: [],
                jsApiParameters:{},
                coupon:[], // 优惠券列表
                money:0
            }
        },
        mounted() {
            // if(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){
            //    return location.reload();
            // }
            //
            this.util.hideOptionMenu();
            this.id = this.util.getQueryStr('id');
            this.type = this.util.getQueryStr('type') || 1;
            console.log('this.type ',this.type )
            this.init();
        },
        methods:{
            init(){
                this.getUserInfo();
            },
            getCourseCoupon(){
                this.util.server.mini_coupon.course_coupon({
                    data:{
                        course_id:this.id
                    },
                    callback:(res => {
                        if (res.code == 1){
                            var data = res.data;
                            var coupon_arr = [];

                            for (var i = 0; i < data.items.length; i++){
                                var item = data.items[i];
                                var condition = '';
                                var money = 0;
                                var unitDesc = '';
                                var value = 0;

                                if((item.coupon.full_money*1) == 0){
                                    condition = '无门槛使用';
                                }else{
                                    condition = '满'+(item.coupon.full_money*1)+'元使用'
                                }

                                if (item.coupon.coupon_type == 1) {
                                    money = item.coupon.money * 1;
                                    value = money * 100;
                                    unitDesc = '元';
                                }else if (item.coupon.coupon_type == 2) {
                                    money = item.coupon.discount * 1;
                                    value = ((this.params.money*1) - ((this.params.money*1) * (money/10))) * 100;
                                    unitDesc = '折';
                                }

                                var arr = {
                                    id : item.coupon_id,
                                    name : item.coupon_name,
                                    condition : condition,
                                    startAt : item.coupon.use_time_start,
                                    endAt : item.coupon.use_time_end,
                                    description : condition,
                                    value : value,
                                    valueDesc : money,
                                    unitDesc : unitDesc,
                                    coupon_user_id:item.coupon_user_id
                                };

                                coupon_arr.push(arr);
                            }

                            this.coupons = coupon_arr;
                        }
                    })
                })
            },
            getCourseDetail(){
                var _self=this;
                this.util.server.mini_course.set_detail({
                    data: {
                        course_id: this.id
                    },
                    callback: (res => {
                        var data= res.data;

                        this.util.tansPics(data, 'cover', {
                            default_img: '',
                            style: 'w375'
                        });

                        this.params = data;
                        this.money = data.money;
                        this.showBody=true;

                        this.getCourseCoupon();
                    })
                });
            },
            getStageDetail(){
                var _self=this;
                this.util.server.mini_training.get_stage_detail({
                    data: {
                        training_stage_id: this.id
                    },
                    callback: (res => {
                        var data= res.data;

                        this.util.tansPics(data, 'cover_url', {
                            default_img: '',
                            style: 'w375'
                        });
                        data.cover = data.cover_url
                        this.params = data;
                        this.money = data.money;
                        this.showBody=true;

                        this.getCourseCoupon();
                    })
                });
            },
            getUserInfo(){
                this.util.server.mini_user.info({
                    callback:(res => {
                        if(!res.data.platform_open_id){
                            location.href = '/mini/login/platform?user_id='+res.data.user_id+'&redirect='+encodeURIComponent(location.href)+'&token='+this.util.token;
                        }else{
                            if(this.type==2){
                                this.getStageDetail();
                            }else{
                                this.getCourseDetail();
                            }
                        }
                    })
                })
            },
            payOrder(){
                if(this.type==2){
                    this.payOrderTraining();
                }else{
                    this.payOrderCourse();
                }
            },
            payOrderTraining(){
                const _self = this;
                var coupon_user_id = '';
                var coupon_money = '';
                if(this.chosenCoupon > -1){
                    coupon_user_id = this.coupons[this.chosenCoupon].coupon_user_id;
                    coupon_money = (this.coupons[this.chosenCoupon].value/100);
                }
                this.util.server.mini_training.order_training({
                    data:{
                        training_stage_id: this.id,
                        pay_money:this.money,
                        coupon_user_id:coupon_user_id,
                        sum_money:this.params.money,
                        coupon_money:coupon_money

                    },
                    callback:(res => {
                        if(res.code == -1){
                            return
                        }
                        if (res.code > 200000){
                            return this.util.showToast({
                                message:res.msg,
                                duration:3500
                            })
                        }
                        if(res.data.pay_type==4){// 免费支付成功，直接跳转
                            _self.util.showToast({
                                message:'支付成功,即将跳转',
                                duration:1000
                            })
                            setTimeout(function () {
                                location.replace(_self.util.payRedirect.get());
                            },2000)
                        }else{
                            this.jsApiParameters = res.data.jsApiParameters;

                            if(document.addEventListener){
                                document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(), false);
                            }else if (document.attachEvent){
                                document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady());
                                document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady());
                            }else{
                                this.onBridgeReady();
                            }
                        }
                        
                    })
                })
            },
            payOrderCourse(){
                const _self = this;
                var coupon_user_id = '';
                var coupon_money = '';
                if(this.chosenCoupon > -1){
                    coupon_user_id = this.coupons[this.chosenCoupon].coupon_user_id;
                    coupon_money = (this.coupons[this.chosenCoupon].value/100);
                }
                this.util.server.mini_pay.order_course({
                    data:{
                        course_id: this.id,
                        pay_money:this.money,
                        coupon_user_id:coupon_user_id,
                        sum_money:this.params.money,
                        coupon_money:coupon_money

                    },
                    callback:(res => {
                        if(res.code == -1){
                            return
                        }
                        if (res.code > 200000){
                            return this.util.showToast({
                                message:res.msg,
                                duration:3500
                            })
                        }

                        if(res.data.pay_type==4){// 免费支付成功，直接跳转
                            _self.util.showToast({
                                message:'支付成功,即将跳转',
                                duration:1000
                            })
                            setTimeout(function () {
                                location.replace(_self.util.payRedirect.get());
                            },2000)
                        }else{
                            this.jsApiParameters = res.data.jsApiParameters;

                            if(document.addEventListener){
                                document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(), false);
                            }else if (document.attachEvent){
                                document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady());
                                document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady());
                            }else{
                                this.onBridgeReady();
                            }
                        }
                    })
                })
            },
            onBridgeReady(){
                var _self=this;
                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest', {
                        "appId":this.jsApiParameters.appId,     //公众号名称，由商户传入
                        "timeStamp":this.jsApiParameters.timeStamp,         //时间戳，自1970年以来的秒数
                        "nonceStr":this.jsApiParameters.nonceStr, //随机串
                        "package":this.jsApiParameters.package,
                        "signType":this.jsApiParameters.signType,         //微信签名方式：
                        "paySign":this.jsApiParameters.paySign //微信签名
                    },
                    function(res){
                        if(res.err_msg == "get_brand_wcpay_request:ok" ){
                            // 使用以上方式判断前端返回,微信团队郑重提示：
                            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                            Toast({
                                message:'支付成功',
                                icon:'success',
                                duration:2000
                            });
                        }else{
                            Toast({
                                message:'支付失败',
                                icon:'cross',
                                duration:2000
                            });
                        }
                        setTimeout(function () {
                            location.replace(_self.util.payRedirect.get());
                        },2000)
                    });
            },
            onChange(index) {
                this.showList = false;
                this.chosenCoupon = index;

                if(index > -1){
                    var temp_money = parseFloat((this.params.money*1) - (this.coupons[index].value*1/100)).toFixed(2);
                    // 解决为零情况
                    this.money = temp_money<0?0:temp_money
                }else{
                    this.money =this.params.money*1;
                }

            },
        }
    }
</script>

<style scoped>
    .payment{
        position: fixed;
        bottom: 0;
        background-color: #FFFFFF;
        padding: 0 18px;
        padding-bottom: env(safe-area-inset-bottom);
        width: 100%;
        box-sizing: border-box;
        color: #3a3a3a;
        font-size: 16px;
        height: 62px;
        line-height: 62px;
    }
    .go-payment{
        padding: 10px 48px;
        position: absolute;
        top: 0;
        background-color: #00CC00;
        border-radius: 30px;
        right: 0;
        color: #fff;
        margin-right: 18px;
        margin-top: 12px;
        line-height: 16px;
    }
    .payment-money{
        color: #f30;
        font-size: 20px;
    }
    .van-card__thumb{
        width: 108px;
    }
    .van-card__price{
        color: #f30;
    }
</style>
